// extracted by mini-css-extract-plugin
module.exports = {"root":"StravaProgressTracker_root__r34JM","heading":"StravaProgressTracker_heading__rT_RW"};